// extracted by mini-css-extract-plugin
module.exports = {"buttons":"button_buttons__1FTYz","ghost":"button_ghost__2NpaV","groups":"button_groups__A5PYx","panel-extra":"button_panel-extra__109pC"};